export default __webpack_public_path__ + "static/media/pencil.icon.8b211ee7.svg";